import {httpClient} from '../../common/api/HttpClient';

export const clubApi = {
    findById: (clubId) => httpClient.get(`clubs/${clubId}`),
    findAll: () => httpClient.get(`clubs/`),
    createOrUpdateClub: (club) => httpClient.post(`clubs/`, club),
    deleteClub: (clubId) => httpClient.delete(`clubs/?clubId=${clubId}`)
};

export default clubApi;
